<template>
    <div class="content">
        <div class="title">关于协会</div>
        <div class="list">
            <div v-for="(item, index) in aboutxiehuiObj" :key="index" class="card" @click="go(index)">
                <img :src="item.image">
                <div class="card-content">
                    <div class="title">{{item.title}}</div>
                    <div class="info">{{item.intro}}</div>
                    <div class="time">{{item.date}}</div>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
    computed: mapState([
        'aboutxiehuiObj'
    ]),
    data() {
        return {
            arr:[
                {title:'IFM简介',img:'',content:'国际财务管理师（International Finance Manager简称IFM）是国际财务管理专业领域的',time:'2020-07-07'},
                {title:'理事会成员',img:'',content:'此规定同时适用于四个级别的国际财务管理师（EIFM、AIFM、IFM、SIFM）',time:'2020-07-07'},
                {title:'IFM在中国',img:'',content:'此规定同时适用于四个级别的国际财务管理师（EIFM、AIFM、IFM、SIFM）',time:'2020-07-07'},
            ]
        }
    },
    methods: {
        go(index){
            console.log('index', index);
            switch(index){
                case 'jianjie':
                    this.$router.push('/ifmDesc');
                    break;
                case 'lishihui':
                    this.$router.push('/ifmLishihui');
                    break;
                case 'zaizhongguo':
                    this.$router.push('/ifmInChina');
                    break;
                case 'zjtd':
                    this.$router.push('/ifmGrop');
                    break;
            }
        }
    },
}
</script>
<style lang="scss" scoped>
.content{
    width:1120px;
    margin:auto;
    box-sizing: border-box;
    padding: 30px;
    background: #fff;
    .title{
        font-size: 22px;
        color: #235483;
        letter-spacing: 0.62px;
        font-weight: 600;
    }
    .list{
        width:100%;
        display: flex;
        margin-top: 25px;
        .card{
            background: #F0F0F0;
            width:240px;
            margin-right: 30px;
            cursor: pointer;
            img{
                height:130px;
                width:100%;
            }
            .card-content{
                box-sizing: border-box;
                padding: 15px 15px 28px 20px;
                .title{
                    font-size: 16px;
                    color: #333333;
                    letter-spacing: 0.45px;
                    font-weight: 600;
                    margin-bottom: 13px;
                }
                .info{
                    font-size: 14px;
                    color: #333333;
                    letter-spacing: 0.4px;
                    font-weight: 400;
                    margin-bottom: 12px;
                }
                .time{
                    font-size: 14px;
                    color: #3B3B3B;
                    letter-spacing: 0.4px;
                    font-weight: 400;
                }
            }
        }
    }
}
</style>
